import {
  Component,
  AfterViewInit,
  ChangeDetectorRef,
  Renderer2,
  Inject,
} from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DOCUMENT } from '@angular/common';
import {
  AuthenticationService,
  AppSettings,
  HelperService,
} from '../../services/_services';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';

declare var $: any;
@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
})
export class NavigationComponent implements AfterViewInit {
  navLogo: string = '';
  public writing4Money = false;

  public activeUser: any;
  public activeRoute: any;
  public routerSubscription: any;
  public newLeads_Count: any = 0;
  public missedAlets_Count: any = 0;
  public newAppointments_Count: any;
  public leadsInterval: any;
  public loading: any = false;
  public pendingInquiries: any = 0;
  public sidebarToggle: any = false;
  public navDateTime: any = false;
  public showNav: any = true;
  public myInterval: any;
  public leadsCount = 0;
  public writerFeedback: any = false;
  public FeedbackModalFlag: any = false;
  public FeedbackPercentPositive: any;
  public FeedbackPercentNegative: any;
  public menuBtnClick: any = false;

  public menuList: any = {
    newType: [
      {
        name: 'All Submissions',
        route: 'feedback',
        notiCount: 0,
        notiVar: 'leadsCount',
        active: true,
        checkInclude: false,
        showInMenu: true,
        image: 'leads',
      },
    ],
    SuperAdmin: [
      {
        name: 'Leads',
        route: '/',
        notiCount: 0,
        notiVar: 'leadsCount',
        active: true,
        checkInclude: false,
        showInMenu: true,
        image: 'leads',
      },
      {
        name: 'Signups',
        route: '/signups',
        notiCount: 0,
        notiVar: '',
        active: false,
        checkInclude: false,
        showInMenu: true,
        image: 'manage-profile',
      },
      {
        name: 'User Packages',
        route: '/user-packages',
        notiCount: 0,
        notiVar: '',
        active: false,
        checkInclude: false,
        showInMenu: true,
        image: 'user-packages',
      },
      {
        name: 'Un-Paid Orders',
        route: '/unpaid-orders',
        notiCount: 0,
        notiVar: 'unpaidCount',
        active: false,
        checkInclude: false,
        showInMenu: true,
        image: 'unpaid-order',
      },

      {
        name: 'Order Management',
        route: '/order-management',
        notiCount: 0,
        notiVar: '',
        active: false,
        checkInclude: false,
        showInMenu: true,
        image: 'order-management',
      },
      {
        name: 'Sales Agent Stats',
        route: '/sales-agent-stats',
        notiCount: 0,
        notiVar: '',
        active: false,
        checkInclude: false,
        showInMenu: true,
        image: 'sales-agent-stats',
      },
      {
        name: 'Manage Team',
        route: '/manage-team',
        notiCount: 0,
        notiVar: '',
        active: false,
        checkInclude: false,
        showInMenu: true,
        image: 'manage-team',
      },
      {
        name: 'Manage Customers',
        route: '/manage-customers',
        notiCount: 0,
        notiVar: '',
        active: false,
        checkInclude: false,
        showInMenu: true,
        image: 'completed-orders',
      },
      {
        name: 'All Closed Orders',
        route: '/closed-orders',
        notiCount: 0,
        notiVar: '',
        active: false,
        checkInclude: false,
        showInMenu: true,
        image: 'closed-orders',
      },
      {
        name: 'Sales History',
        route: '/sales-history',
        notiCount: 0,
        notiVar: 'unpaidCount',
        active: false,
        checkInclude: false,
        showInMenu: true,
        image: 'unpaid-order',
      },
      // { name: "Writer Payment",           route: "/writer-payment",           notiCount: 0, notiVar: '',            active: false, checkInclude: false,  showInMenu: true, image: "writer-payment"},
      {
        name: 'Order Classification',
        route: '/order-classification',
        notiCount: 0,
        notiVar: '',
        active: false,
        checkInclude: false,
        showInMenu: true,
        image: 'order-management',
      },

      {
        name: 'AI Subscriptions',
        route: '/ai-subscriptions',
        notiCount: 0,
        notiVar: '',
        active: false,
        checkInclude: false,
        showInMenu: true,
        image: 'leads',
      },
      // { name: "Available Subscriptions",       route: "/sales/available-subscriptions",       notiCount: 0, notiVar: '',            active: false,   checkInclude: false,  showInMenu: true, image: "leads"},
      // Dont Show in Menu
      {
        name: 'Subscription Link',
        route: '/ai-subscription-link',
        parent: '',
        notiCount: 0,
        active: false,
        checkInclude: true,
        showInMenu: false,
        image: '',
      },
      {
        name: 'Modify Order',
        route: '/modify-order',
        parent: '/order-management',
        notiCount: 0,
        active: false,
        checkInclude: true,
        showInMenu: false,
        image: '',
      },
      {
        name: 'Order Details',
        route: '/order-detail',
        notiCount: 0,
        active: false,
        checkInclude: true,
        showInMenu: false,
        image: '',
      },
      {
        name: 'Update User',
        route: '/update-user',
        notiCount: 0,
        active: false,
        checkInclude: true,
        showInMenu: false,
        image: '',
      },
      {
        name: 'Add User',
        route: '/add-user',
        notiCount: 0,
        active: false,
        checkInclude: true,
        showInMenu: false,
        image: '',
      },
      {
        name: 'Customer Orders',
        route: '/customer-orders',
        parent: '/manage-customers',
        notiCount: 0,
        active: false,
        checkInclude: true,
        showInMenu: false,
        image: '',
      },
    ],
    Sales: [
      {
        name: 'Search Order',
        route: '/search-orders',
        notiCount: 0,
        notiVar: '',
        active: false,
        checkInclude: false,
        showInMenu: true,
        image: 'search-orders',
      },
      {
        name: 'Available Leads',
        route: '/sales/available-leads',
        notiCount: 0,
        notiVar: 'leadsCount',
        active: false,
        checkInclude: false,
        showInMenu: true,
        image: 'leads',
      },
      {
        name: 'Un-Paid Orders',
        route: '/sales/unpaid-orders',
        notiCount: 0,
        notiVar: 'unpaidCount',
        active: false,
        checkInclude: false,
        showInMenu: true,
        image: 'unpaid-order',
      },
      {
        name: 'User Packages',
        route: '/sales/user-packages',
        notiCount: 0,
        notiVar: 'packageCount',
        active: false,
        checkInclude: false,
        showInMenu: true,
        image: 'user-packages',
      },

      {
        name: 'Signups',
        route: '/signups',
        notiCount: 0,
        notiVar: '',
        active: false,
        checkInclude: false,
        showInMenu: true,
        image: 'manage-profile',
      },
      {
        name: 'My Closed Orders',
        route: '/sales/closed-orders',
        notiCount: 0,
        notiVar: '',
        active: false,
        checkInclude: false,
        showInMenu: true,
        image: 'closed-orders',
      },
      {
        name: 'Available Subscriptions',
        route: '/sales/available-subscriptions',
        notiCount: 0,
        notiVar: '',
        active: false,
        checkInclude: false,
        showInMenu: true,
        image: 'leads',
      },

      // Dont Show in Menu
      {
        name: 'Subscription Link',
        route: '/ai-subscription-link',
        parent: '',
        notiCount: 0,
        active: false,
        checkInclude: true,
        showInMenu: false,
        image: '',
      },
      {
        name: 'Modify Order',
        route: '/modify-order',
        parent: '/order-management',
        notiCount: 0,
        active: false,
        checkInclude: true,
        showInMenu: false,
        image: '',
      },
      {
        name: 'Order Details',
        route: '/order-detail',
        notiCount: 0,
        active: false,
        checkInclude: true,
        showInMenu: false,
        image: '',
      },
    ],
    Support: [
      {
        name: 'Search Order',
        route: '/search-orders',
        notiCount: 0,
        notiVar: '',
        active: false,
        checkInclude: false,
        showInMenu: true,
        image: 'search-orders',
      },
      {
        name: 'New Orders',
        route: '/support/new-orders',
        notiCount: 0,
        notiVar: 'newOrderCount',
        active: false,
        checkInclude: false,
        showInMenu: true,
        image: 'new-orders',
      },
      {
        name: 'Order In-Progress',
        route: '/support/order-in-progress',
        notiCount: 0,
        notiVar: 'oipCount',
        active: false,
        checkInclude: false,
        showInMenu: true,
        image: 'order-in-progress',
      },
      {
        name: 'Submissions',
        route: '/support/submissions',
        notiCount: 0,
        notiVar: 'subCount',
        active: false,
        checkInclude: false,
        showInMenu: true,
        image: 'submissions',
      },
      {
        name: 'Revisions',
        route: '/support/new-revisions',
        notiCount: 0,
        notiVar: 'revCount',
        active: false,
        checkInclude: false,
        showInMenu: true,
        image: 'new-revisions',
      },
      {
        name: 'Progress Requests',
        route: '/support/progress-requests',
        notiCount: 0,
        notiVar: '',
        active: false,
        checkInclude: false,
        showInMenu: true,
        image: 'progress-requests',
      },
      {
        name: 'CWHP',
        route: '/support/cwhp',
        notiCount: 0,
        notiVar: 'cwhpCount',
        active: false,
        checkInclude: false,
        showInMenu: true,
        image: 'cwhp',
      },

      // Dont Show in Menu
      {
        name: 'Subscription Link',
        route: '/ai-subscription-link',
        parent: '',
        notiCount: 0,
        active: false,
        checkInclude: true,
        showInMenu: false,
        image: '',
      },
      {
        name: 'Modify Order',
        route: '/modify-order',
        parent: '/order-management',
        notiCount: 0,
        active: false,
        checkInclude: true,
        showInMenu: false,
        image: '',
      },
      {
        name: 'Order Details',
        route: '/order-detail',
        parent: null,
        notiCount: 0,
        active: false,
        checkInclude: true,
        showInMenu: false,
        image: '',
      },
      {
        name: 'All Revisions',
        route: '/support/all-revisions',
        parent: '/support/new-revisions',
        notiCount: 0,
        active: false,
        checkInclude: true,
        showInMenu: false,
        image: '',
      },
      {
        name: 'Revisions in Progress',
        route: '/support/revisions-in-progress',
        parent: '/support/new-revisions',
        notiCount: 0,
        active: false,
        checkInclude: true,
        showInMenu: false,
        image: '',
      },
      {
        name: 'Invalid Revisions',
        route: '/support/invalid-revisions',
        parent: '/support/new-revisions',
        notiCount: 0,
        active: false,
        checkInclude: true,
        showInMenu: false,
        image: '',
      },
      {
        name: 'Revised Work',
        route: '/support/revised-work',
        parent: '/support/new-revisions',
        notiCount: 0,
        active: false,
        checkInclude: true,
        showInMenu: false,
        image: '',
      },
      {
        name: 'Writer Progress',
        route: '/support/writers-progress',
        parent: '/support/order-in-progress',
        notiCount: 0,
        active: false,
        checkInclude: true,
        showInMenu: false,
        image: '',
      },
      {
        name: 'Writer Subject',
        route: '/support/writers-subjects',
        parent: '/support/order-in-progress',
        notiCount: 0,
        active: false,
        checkInclude: true,
        showInMenu: false,
        image: '',
      },
      {
        name: 'Charge Back',
        route: '/support/chargeback',
        parent: '/support/submissions',
        notiCount: 0,
        active: false,
        checkInclude: true,
        showInMenu: false,
        image: '',
      },
    ],
    ProofreaderManager: [
      {
        name: 'Available Orders',
        route: '/proofreaders/available-orders',
        notiCount: 0,
        notiVar: '',
        active: false,
        checkInclude: false,
        showInMenu: true,
        image: 'available-orders',
      },
      {
        name: 'Order In-Progress',
        route: '/proofreaders/order-in-progress',
        notiCount: 0,
        notiVar: '',
        active: false,
        checkInclude: false,
        showInMenu: true,
        image: 'order-in-progress',
      },
      {
        name: 'Completed Orders',
        route: '/proofreaders/completed-orders',
        notiCount: 0,
        notiVar: '',
        active: false,
        checkInclude: false,
        showInMenu: true,
        image: 'completed-orders',
      },
      {
        name: 'Proofreader Progress',
        route: '/proofreaders/progress',
        notiCount: 0,
        notiVar: '',
        active: false,
        checkInclude: false,
        showInMenu: true,
        image: 'proofreader-progress',
      },

      // Dont Show in Menu
      {
        name: 'Order Details',
        route: '/order-detail',
        notiCount: 0,
        active: false,
        checkInclude: true,
        showInMenu: false,
        image: '',
      },
    ],
    Proofreader: [
      {
        name: 'Available Orders',
        route: '/proofreaders/available-orders',
        notiCount: 0,
        notiVar: '',
        active: false,
        checkInclude: false,
        showInMenu: true,
        image: 'available-orders',
      },
      {
        name: 'Order In-Progress',
        route: '/proofreaders/order-in-progress',
        notiCount: 0,
        notiVar: '',
        active: false,
        checkInclude: false,
        showInMenu: true,
        image: 'order-in-progress',
      },
      {
        name: 'Completed Orders',
        route: '/proofreaders/completed-orders',
        notiCount: 0,
        notiVar: '',
        active: false,
        checkInclude: false,
        showInMenu: true,
        image: 'completed-orders',
      },

      // Dont Show in Menu
      {
        name: 'Order Details',
        route: '/order-detail',
        notiCount: 0,
        active: false,
        checkInclude: true,
        showInMenu: false,
        image: '',
      },
    ],
    Writer: [
      // { name: "Search Order",          route: "/search-orders",         notiCount: 0,            active: false,   checkInclude: false,  showInMenu: true, image:"search-orders"},
      {
        name: 'Writers Dashboard',
        route: '/writers-dashboard',
        notiCount: 0,
        notiVar: '',
        active: false,
        checkInclude: false,
        showInMenu: false,
        image: '',
      },
      {
        name: 'Available Orders',
        route: '/writers/available-orders',
        notiCount: 0,
        notiVar: '',
        active: false,
        checkInclude: false,
        showInMenu: true,
        image: 'available-orders',
      },
      {
        name: 'Order In-Progress',
        route: '/writers/order-in-progress',
        notiCount: 0,
        notiVar: '',
        active: false,
        checkInclude: false,
        showInMenu: true,
        image: 'order-in-progress',
      },
      {
        name: 'Completed Orders',
        route: '/writers/completed-orders',
        notiCount: 0,
        notiVar: '',
        active: false,
        checkInclude: false,
        showInMenu: true,
        image: 'completed-orders',
      },
      {
        name: 'Revisions',
        route: '/writers/view-revisions',
        notiCount: 0,
        notiVar: '',
        active: false,
        checkInclude: false,
        showInMenu: true,
        image: 'new-revisions',
      },
      {
        name: 'Manage Profile',
        route: '/manage-profile',
        notiCount: 0,
        notiVar: '',
        active: false,
        checkInclude: false,
        showInMenu: true,
        image: 'manage-profile',
      },

      // Dont Show in Menu
      {
        name: 'Order Details',
        route: '/order-detail',
        notiCount: 0,
        active: false,
        checkInclude: true,
        showInMenu: false,
        image: '',
      },
    ],
    WriterManager: [
      {
        name: 'Available Orders',
        route: '/writers/available-orders',
        notiCount: 0,
        notiVar: '',
        active: false,
        checkInclude: false,
        showInMenu: true,
        image: 'available-orders',
      },
      {
        name: 'Order In-Progress',
        route: '/writers/order-in-progress',
        notiCount: 0,
        notiVar: '',
        active: false,
        checkInclude: false,
        showInMenu: true,
        image: 'order-in-progress',
      },
      {
        name: 'Submissions',
        route: '/writers/submissions',
        notiCount: 0,
        notiVar: '',
        active: false,
        checkInclude: false,
        showInMenu: true,
        image: 'submissions',
      },
      {
        name: 'Revisions',
        route: '/writers/view-revisions',
        notiCount: 0,
        notiVar: '',
        active: false,
        checkInclude: false,
        showInMenu: true,
        image: 'new-revisions',
      },
      {
        name: 'Writers Statistics',
        route: '/writers/writers-statistics',
        notiCount: 0,
        notiVar: '',
        active: false,
        checkInclude: false,
        showInMenu: true,
        image: 'writers-statistics',
      },
      {
        name: 'Manage Team',
        route: '/manage-team',
        notiCount: 0,
        notiVar: '',
        active: false,
        checkInclude: false,
        showInMenu: true,
        image: 'manage-team',
      },

      // Dont Show in Menu
      {
        name: 'Order Details',
        route: '/order-detail',
        notiCount: 0,
        active: false,
        checkInclude: true,
        showInMenu: false,
        image: '',
      },
      {
        name: 'Update User',
        route: '/update-user',
        notiCount: 0,
        active: false,
        checkInclude: true,
        showInMenu: false,
        image: '',
      },
      {
        name: 'Add User',
        route: '/add-user',
        notiCount: 0,
        active: false,
        checkInclude: true,
        showInMenu: false,
        image: '',
      },
    ],
    QualityAssurance: [
      {
        name: 'All Leads',
        route: '/qa/all-leads',
        notiCount: 0,
        notiVar: '',
        active: false,
        checkInclude: false,
        showInMenu: true,
        image: 'leads',
      },
      {
        name: 'Un-Paid Orders',
        route: '/qa/unpaid-orders',
        notiCount: 0,
        notiVar: '',
        active: false,
        checkInclude: false,
        showInMenu: true,
        image: 'unpaid-order',
      },
      {
        name: 'Signups',
        route: '/signups',
        notiCount: 0,
        notiVar: '',
        active: false,
        checkInclude: false,
        showInMenu: true,
        image: 'manage-profile',
      },
      {
        name: 'Sales Agent Stats',
        route: '/qa/sales-agent-stats',
        notiCount: 0,
        notiVar: '',
        active: false,
        checkInclude: false,
        showInMenu: true,
        image: 'sales-agent-stats',
      },
      {
        name: 'Order Management',
        route: '/qa/order-management',
        notiCount: 0,
        notiVar: '',
        active: false,
        checkInclude: false,
        showInMenu: true,
        image: 'order-management',
      },
      {
        name: 'All Subscriptions',
        route: '/qa/all-subscriptions',
        notiCount: 0,
        notiVar: '',
        active: false,
        checkInclude: false,
        showInMenu: true,
        image: 'leads',
      },

      // Dont Show in Menu
      {
        name: 'Order Details',
        route: '/order-detail',
        notiCount: 0,
        notiVar: '',
        active: false,
        checkInclude: true,
        showInMenu: false,
        image: '',
      },
    ],
  };

  public menus: any = [];

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private authenticationService: AuthenticationService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private helperService: HelperService,
    private cdr: ChangeDetectorRef,
    private renderer: Renderer2
  ) {
    const baseUrl = this.document.location.origin;

    // Set the logo URL based on the base URL
    if (baseUrl.includes('writing4money')) {
      this.navLogo = 'assets/images/w4m-nav-logo.svg'; // Default logo
      this.writing4Money = true;
    } else {
      this.navLogo = 'assets/images/skyscrapers.svg'; // Replace with your logo for route1
      this.writing4Money = false;
    }

    // toggle price input
    this.renderer.listen('window', 'click', (e: Event) => {
      if (!this.menuBtnClick) {
        $('#writerFeedback_modal').modal('hide');
      }
      this.menuBtnClick = false;
    });

    this.authenticationService.isBrowser.subscribe((isBrowser) => {
      if (isBrowser) {
        // Get Current User
        this.activeUser = this.authenticationService.get_currentUserValue();

        // Set Menus
        if (this.activeUser.Portal_SuperAdmin) {
          this.menus = this.menuList.SuperAdmin;
          if (this.activeUser.is_projectmanager) {
            this.menus[5].showInMenu = false;
          }
          this.allLeadsCount();
        } else if (this.activeUser.Portal_Sales) {
          this.menus = this.menuList.Sales;
          this.allLeadsCount();
        } else if (this.activeUser.Portal_Support) {
          this.menus = this.menuList.Support;
          this.allLeadsCount();
        } else if (this.activeUser.is_proofreader_manager) {
          this.menus = this.menuList.ProofreaderManager;
        } else if (this.activeUser.is_proofreader) {
          this.menus = this.menuList.Proofreader;
        } else if (this.activeUser.is_writer) {
          this.menus = this.menuList.Writer;
          if (this.writing4Money) {
            this.menus.push({
              name: 'Payment History',
              route: '/writers/payment-history',
              notiCount: 0,
              notiVar: '',
              active: false,
              checkInclude: false,
              showInMenu: true,
              image: 'writers-statistics',
            });
            // console.log("this.writing4Money",this.writing4Money,this.menus);
          }
          this.checkWriterFeedback();
        } else if (this.activeUser.is_writermanager) {
          this.menus = this.menuList.WriterManager;
        } else if (this.activeUser.is_qualityassurance) {
          this.menus = this.menuList.QualityAssurance;
        } else if (this.activeUser.is_newType) {
          this.menus = this.menuList.newType;
        }

        // Logout of application if no menu found
        if (this.menus.length == 0) {
          this.authenticationService.simpleLogout();
        }

        // // Get Initial Counts
        // if(this.activeUser.only_payment_tab != '1') {
        //   // this.getAppointments_Count();
        //
        //   this.getLeads_Count();
        //   this.getMissedAlets_Count();
        //
        // let self = this;
        // this.leadsInterval = setInterval(function() {
        //     self.getLeads_Count();
        //     self.getMissedAlets_Count();
        //   }, 25000);
        // }
        //

        this.routerSubscription = this.router.events.subscribe((val) => {
          if (val instanceof NavigationEnd) {
            this.activeRoute = val.url;

            // console.log("this.activeRoute: ",this.activeRoute.indexOf('registration-form'));

            if (this.activeRoute == '/writers-dashboard') {
              this.showNav = false;
            } else {
              this.showNav = true;
            }

            let menuFound = false;
            for (let i = 0; i < this.menus.length; i++) {
              if (
                !this.menus[i].checkInclude &&
                this.menus[i].route == this.activeRoute
              ) {
                this.menus[i].active = true;
                menuFound = true;
              } else if (
                this.menus[i].checkInclude &&
                this.activeRoute.indexOf(this.menus[i].route) != '-1'
              ) {
                this.menus[i].active = true;
                menuFound = true;
              } else this.menus[i].active = false;

              // Set menu parent active
              if (this.menus[i].active && this.menus[i].parent) {
                for (let j = 0; j < this.menus.length; j++) {
                  if (this.menus[i].parent == this.menus[j].route) {
                    this.menus[j].active = true;
                    break;
                  }
                }
              }
            }

            // If menu not found then redirect the user to first page
            if (!menuFound) {
              this.router.navigate([this.menus[0].route]);
              this.menus[0].active = true;
            }
          }
        });
      }
    });
  }

  ngAfterViewInit() {}

  ngOnInit() {
    this.navDateTime = this.convertTZ(new Date(), 'America/Los_Angeles');
    this.myInterval = setInterval(() => {
      this.navDateTime = this.convertTZ(new Date(), 'America/Los_Angeles');
    }, 20000);
  }

  convertTZ(date, tzString) {
    return new Date(
      (typeof date === 'string' ? new Date(date) : date).toLocaleString(
        'en-US',
        { timeZone: tzString }
      )
    );
  }

  allLeadsCount() {
    let url = AppSettings.API_ENDPOINT + 'admin/leads-count';

    this.helperService.httpPostRequests(url, {}).then((resp) => {
      if (typeof resp != 'undefined' && resp.status == 'OK') {
        for (let i = 0; i < this.menus.length; i++) {
          if (resp.counts[this.menus[i].notiVar])
            this.menus[i].notiCount = resp.counts[this.menus[i].notiVar];
        }
      }
    });
  }

  ngOnDestroy(): void {
    if (typeof this.routerSubscription != 'undefined') {
      this.routerSubscription.unsubscribe();
    }
    clearInterval(this.myInterval);
    // clearInterval(this.leadsInterval);
  }

  logout() {
    // this.authenticationService.simpleLogout();
    // this.router.navigate(['/login']);

    // Show Loader
    this.loading = true;

    this.authenticationService
      .logout()
      .then((resp) => {
        // console.log("resp: ",resp);
        this.router.navigate(['/login']);

        // Hode Loader
        this.loading = false;
      })
      .catch((error) => {
        console.log('error: ', error);

        // Hode Loader
        this.loading = false;
      });
  }

  sidebarToggler() {
    this.sidebarToggle = !this.sidebarToggle;
    $('.overlay-dash').toggleClass('blurr');
    $('body').toggleClass('noscroll');
  }

  checkWriterFeedback() {
    let url = AppSettings.API_ENDPOINT + 'writers/get-clientfeedback-rating';
    this.helperService.httpGetRequests(url).then((resp) => {
      if (typeof resp != 'undefined' && resp.status == 'OK') {
        this.writerFeedback = resp;
        // console.log("resp",this.writerFeedback);
      }
      if (typeof resp != 'undefined' && resp.status == 'ERROR') {
      }
    });
  }

  clientModal() {
    if (typeof $ != 'undefined') {
      var progressBarP = $('.js-progress-bar');
      $(progressBarP).css('stroke-dashoffset', 100);
      var progressBarN = $('.js-progress-barNeg');
      $(progressBarN).css('stroke-dashoffset', 100);

      this.FeedbackPercentPositive = 0;
      this.FeedbackPercentNegative = 0;
      this.FeedbackModalFlag = true;
      this.cdr.detectChanges();
      $('#writerFeedback_modal').modal('show');
      $('.modal-backdrop.show').hide();

      setTimeout(() => {
        if (this.writerFeedback.positive != 0) {
          var percentageP =
            (this.writerFeedback.positive / this.writerFeedback.total) * 100;
          this.FeedbackPercentPositive = Math.round(percentageP);

          if (this.FeedbackPercentPositive == 50) {
            var percentageCompletedP = percentageP / 100 - 0.1;
            var strokeDashOffsetValueP = 100 - percentageCompletedP * 100;
            var progressBarP = $('.js-progress-bar');
            progressBarP.css('stroke-dashoffset', strokeDashOffsetValueP);
          } else {
            var percentageCompletedP = percentageP / 100 - 0.2;
            var strokeDashOffsetValueP = 100 - percentageCompletedP * 100;
            var progressBarP = $('.js-progress-bar');
            progressBarP.css('stroke-dashoffset', strokeDashOffsetValueP);
          }
        }

        if (this.writerFeedback.negative != 0) {
          var percentageN =
            (this.writerFeedback.negative / this.writerFeedback.total) * 100;
          this.FeedbackPercentNegative = Math.round(percentageN);

          if (this.FeedbackPercentNegative == 50) {
            var percentageCompletedN = percentageN / 100 - 0.1;
            var strokeDashOffsetValueN = 100 - percentageCompletedN * 100;
            var progressBarN = $('.js-progress-barNeg');
            progressBarN.css('stroke-dashoffset', strokeDashOffsetValueN);
          } else {
            var percentageCompletedN = percentageN / 100 - 0.02;
            var strokeDashOffsetValueN = 100 - percentageCompletedN * 100;
            var progressBarN = $('.js-progress-barNeg');
            progressBarN.css('stroke-dashoffset', strokeDashOffsetValueN);
          }
        }
      }, 400);
    }
  }
  parseFloat(value) {
    return parseFloat(value);
  }
  preventCloseOnClick() {
    this.menuBtnClick = true;
  }
}
